import { AxiosResponse } from 'axios';
import { appContextDelete, appContextGet, appContextPost, appContextPut } from './httpCommon/appAxios.service';
import { MARKETPLACE_CARTITEM_ENDPOINTS } from '../constants/apiEndpoints';
import { MarketplaceCartItemRequest, MarketPlaceCartItem } from '../types/interfaces/marketPlace.interfaces';
import { StandardParams } from '../types/interfaces/apiParams.interfaces';

export const addToMarketplaceCart = (payload: MarketplaceCartItemRequest): Promise<AxiosResponse<void>> => {
  return appContextPost(MARKETPLACE_CARTITEM_ENDPOINTS.MARKETPLACE_CART, payload);
};

export const updateMarketplaceCartItem = (
  marketPlaceCartItemId: number,
  payload: MarketplaceCartItemRequest,
): Promise<AxiosResponse<void>> => {
  return appContextPut(`${MARKETPLACE_CARTITEM_ENDPOINTS.MARKETPLACE_CART}/${marketPlaceCartItemId}`, payload);
};

export const getMarketplaceCartItems = (params?: StandardParams): Promise<AxiosResponse<MarketPlaceCartItem[]>> => {
  return appContextGet(MARKETPLACE_CARTITEM_ENDPOINTS.MARKETPLACE_CART, params);
};

export const deleteMarketplaceCartItems = (marketPlaceCartItemIds: number[]): Promise<AxiosResponse<void>> => {
  return appContextDelete(MARKETPLACE_CARTITEM_ENDPOINTS.MARKETPLACE_CART, undefined, marketPlaceCartItemIds);
};
